import { render } from "./SearchBar.vue?vue&type=template&id=64c581a9&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=64c581a9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64c581a9"

export default script